const brand = {
  primary: '#0032A0',
  secondary: '#00843D',
  tal: '#86C543',
  talBorder: 'rgba(0, 132, 61, 0.25)',
  // for demo purposes
  questionBackground: '#0032A0',
  buttonColor: '#0032A0',
  buttonAdditionalColor: '#0032A0',
  buttonAdditonalHover: '#0032A0'
}

const product = {
  success: '#00C48C',
  alert: '#FFCF5C',
  warning: '#FFA26B',
  error: '#FF647C'
}

const grey = {
  grey9: '#2C2A29',
  grey7: '#605F5E',
  grey5: '#A9A9A9',
  grey4: 'rgba(41, 43, 50, 0.08)',
  grey3: '#F0F0F0',
  grey1: '#F7F7F7',
  white: '#FFFFFF'
}

const social = {
  facebook: '#1877F2',
  twitter: '#1DA1F2',
  linkedIn: '#0065A1',
  instagram: '#D93175',
  youTube: '#FF0000',
  medium: '#12100E'
}

const colors = {
  brand,
  product,
  grey,
  social
}

const theme = {
  colors
}

export default theme
